import {
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import sortBy from 'lodash/sortBy';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import ScreeningProviderControls from './ScreeningProviderControls';
import type { Props } from './types';
import type { ScreeningSetupDataEntry } from '../../types';
import SortableActiveProviders from './SortableActiveProviders';

function ScreeningsSetup({ screeningSetupData, editMode, onChange }: Props) {
  if (!screeningSetupData) {
    return null;
  }

  const screeningDataEntries: ScreeningSetupDataEntry[] =
    Object.values(screeningSetupData);
  const activeProviders = sortBy(
    screeningDataEntries.filter(
      (entry: ScreeningSetupDataEntry) => entry.isActive,
    ),
    'order',
  );
  const inactiveProviders = sortBy(
    screeningDataEntries.filter(
      (entry: ScreeningSetupDataEntry) => !entry.isActive,
    ),
    'providerName',
  );

  const renderInactiveProviders = (entries: Array<ScreeningSetupDataEntry>) =>
    entries.map((entry: ScreeningSetupDataEntry) => {
      return (
        <ScreeningProviderControls
          key={entry.providerId}
          data={entry}
          editMode={editMode}
          onChange={onChange}
          activeProviderCount={activeProviders.length}
          activeProviders={activeProviders}
        />
      );
    });

  return (
    <Stack spacing={2}>
      <Stack>
        <Typography variant="titleLarge">
          <FormattedMessage {...messages.title} />
        </Typography>
        <Typography variant="bodySmall" color="text.secondary">
          <FormattedMessage
            {...messages[editMode ? 'subtitleEditMode' : 'subtitleReadonly']}
          />
        </Typography>
      </Stack>
      <Typography variant="titleMedium">
        <FormattedMessage {...messages.activeScreeningProviders} />
      </Typography>
      {activeProviders.length === 0 ? (
        <Typography color="text.secondary">
          <FormattedMessage {...messages.noActiveProviders} />
        </Typography>
      ) : (
        <SortableActiveProviders
          entries={activeProviders}
          editMode={editMode}
          onChange={onChange}
          activeProviderCount={activeProviders.length}
        />
      )}
      <Typography variant="titleMedium">
        <FormattedMessage {...messages.inactiveScreeningProviders} />
      </Typography>
      {inactiveProviders.length === 0 ? (
        <Typography color="text.secondary">
          <FormattedMessage {...messages.noInactiveProviders} />
        </Typography>
      ) : (
        renderInactiveProviders(inactiveProviders)
      )}
    </Stack>
  );
}

export default ScreeningsSetup;
